import { getSubmission } from 'platform/forms-system/src/js/state/selectors';

/**
 * @param {Object} state - Redux state containing `form.submission`
 * @returns {boolean} true when the form has a submission status
 */
export const selectFormSubmitted = state =>
  Boolean(getSubmission(state).status);
